import React from "react";
import PropTypes from "prop-types";
import { ResponsiveBanner } from "../../components/ResponsiveBanner";

const ResponsiveBannerConnector = ({ data }) => (
	<ResponsiveBanner
		url={data.bannerUrl}
		target={data.target}
		description={data.bannerDescription}
		alignment={data.buttonAlignment}
		button={data.button}
		banners={data.banners}
		margins={data.margins}
		useDynamicButton={data.useDynamicButton}
	/>
);

ResponsiveBannerConnector.propTypes = {
	data: PropTypes.shape({
		bannerUrl: PropTypes.string,
		bannerDescription: PropTypes.string,
		target: PropTypes.string,
		buttonAlignment: PropTypes.string,
		button: PropTypes.shape({
			variant: PropTypes.string,
			url: PropTypes.string,
			target: PropTypes.string,
			linkText: PropTypes.string,
		}),
		margins: PropTypes.arrayOf(PropTypes.string),
		useDynamicButton: PropTypes.bool,
		banners: PropTypes.arrayOf([
			PropTypes.shape({
				aspectRatio: PropTypes.string,
				imageWidth: PropTypes.number,
				viewportWidth: PropTypes.number,
				cloudinaryAsset: PropTypes.arrayOf([
					PropTypes.shape({
						format: PropTypes.string,
						height: PropTypes.number,
						width: PropTypes.number,
						version: PropTypes.number,
						public_id: PropTypes.string,
						raw_transformation: PropTypes.string,
						secure_url: PropTypes.string,
						url: PropTypes.string,
					}),
				]),
			}),
		]),
	}).isRequired,
};

export { ResponsiveBannerConnector };
